import { render, staticRenderFns } from "./CountDownProduct.vue?vue&type=template&id=472d5574&scoped=true"
import script from "./CountDownProduct.vue?vue&type=script&lang=js"
export * from "./CountDownProduct.vue?vue&type=script&lang=js"
import style0 from "./CountDownProduct.vue?vue&type=style&index=0&id=472d5574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d5574",
  null
  
)

export default component.exports